// extracted by mini-css-extract-plugin
export default {"Modal":"Style_Modal__eqEKb","Foot":"Style_Foot__Mjf8B","Equipment":"Style_Equipment__ehGGJ"};